import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {getRequest, patchRequest, postRequest} from "../../api";

const initialStepState = {
  step_1: true,
  step_2: false,
  step_3: false,
  step_4: false,
  step_5: false,
  step_6: false,
  access: false,
  update: false,
  file: null,
  img1: null,
  img2: null,
  trainingVoice: null,
  importantPointsVoice: null,
};

const initialMovementsObject = {
    body_parts: [],
    categories: [],
    coach_id: '',
    created_at: "",
    description: "",
    difficulty_id: 0,
    equipments: [],
    file: null,
    img1: null,
    img2: null,
    important_points_voice: null,
    motion_id: '',
    name: "",
    show_for_all: false,
    training_voice: null,
    type_id: 0,
    updated_at: "",
}

export const handleGetMyMovements = createAsyncThunk("myMovements/handleGetMyMovements", async (page) => {
    try {
      const { data } = await getRequest(`/coach/motion/${page}`);
      return data;
    } catch (err) {
      console.error("err", err.response.data.message);
    }
  }
);

export const updateSelectedOrNewMovementData = createAsyncThunk("myMovements/updateSelectedOrNewMovementData", async(allData) => {
    const {myForm, textFormBody, motion_id, dispatch} = allData
    try{
        console.log('in thunk')
        console.log(myForm)
        const {data} = await patchRequest(`/coach/motion/${motion_id}`, myForm)
        console.log('sentData:', data)
        if(data?.is_successful){
            await patchRequest(`/coach/motion/${motion_id}`, textFormBody)
            dispatch(setSelectedOrNewMovementLoading("sentData"))
            setTimeout(() => {
                dispatch(setSelectedOrNewMovementLoading(false))
                window.history.back();
            }, 3000);
        }
        return null
    }
    catch (err) {
        console.error("err", err.response.data.message);
    }
})

export const createNewMovement = createAsyncThunk("myMovements/createNewMovement", async(allData) => {
    const {name, myForm, textFormBody, dispatch} = allData
    try{
        const {data} = await postRequest("/coach/motion", { name })
        if (data?.is_successful) {
            dispatch(updateSelectedOrNewMovementData({myForm: myForm, textFormBody: textFormBody, motion_id: data?.motion_id, dispatch}))
        }
        return {data}
    }
    catch (err) {
        console.log('err', err.response.data.message)
    }
})

const myMovementsSlice = createSlice({
    name: 'myMovements',
    initialState: {
        stepState: initialStepState,
        myMovements: [],
        myMovementsTemp: [],
        selectedOrNewMovement: initialMovementsObject,
        motionId: null,
        body_parts: {
            mainMuscles: [],
            secondaryMuscles: []
        },
        status: {
            myMovementsLoading: false,
            selectedOrNewMovementLoading: null,
            isNotMoreData: true,
        },
    },
    reducers: {
      updateSelectedOrNewMovement: (state, action) => {
        switch (action?.payload?.type){
            case 'all':
                if(action?.payload?.value === 'addNewMovement'){
                    state.selectedOrNewMovement = initialMovementsObject
                }
                else {
                    state.selectedOrNewMovement = action?.payload?.value
                }
                break;
            case 'name':
            case 'difficulty_id':
            case 'type_id':
            case 'show_for_all':
            case 'description':
                state.selectedOrNewMovement[action?.payload?.type] = action?.payload?.value
                break;
            case 'add-equipment':
                let newEquipment = action?.payload?.value
                console.log('value in slice:', typeof newEquipment)
                state.selectedOrNewMovement.equipments = [...state.selectedOrNewMovement.equipments, newEquipment]
                break;
            case 'del-equipment':
                console.log('value in slice2:', action?.payload?.value)
                let newEquipmentArray = state.selectedOrNewMovement.equipments.filter(item => item !== action?.payload?.value)
                state.selectedOrNewMovement.equipments = newEquipmentArray
                break;
            case 'clear-equipments':
                state.selectedOrNewMovement.equipments = []
                break;
            case 'delete-body-parts':
                let filteredBodyParts = state.selectedOrNewMovement.body_parts.filter((item) => {
                    return item.body_part_id !== action?.payload?.value
                })
                state.selectedOrNewMovement.body_parts = filteredBodyParts
                break;
            case 'add-body-parts':
                let newBodyPart = {type: action?.payload?.value?.type, body_part_id: action?.payload?.value?.name}
                state.selectedOrNewMovement.body_parts = [...state.selectedOrNewMovement.body_parts, newBodyPart]
                break;
            case 'add-all-body-parts':
                let musclesArray = action?.payload?.value?.names.map(item => {
                    return {type: action?.payload?.value?.type, body_part_id: item}
                })
                state.selectedOrNewMovement.body_parts = musclesArray
                break;
            case 'clear-body-parts':
                state.selectedOrNewMovement.body_parts = action?.payload?.value
                break;
            default:
                console.log('no action exists')
        }
      },
      setSelectedOrNewMovementLoading: (state, action) => {
          state.status.selectedOrNewMovementLoading = action?.payload
      },
      updateMotionId: (state, action) => {
          state.motionId = action?.payload
      },
      updateMyMovements: (state, action) => {
        state.myMovements = action?.payload;
      },
      updateMainOrSecondaryMuscles: (state, action) => {
          if(action?.payload?.type === 'main'){
              state.body_parts.mainMuscles = action?.payload?.value
          }
          else {
              state.body_parts.secondaryMuscles = action?.payload?.value
          }
      },
      clearAllStepStateData: (state) => {
        state.stepState = {
          ...state.stepState,
          trainingVoice: null,
          file: null,
          img1: null,
          img2: null,
          importantPointsVoice: null,
        };
      },
      setUpdate: (state, action) => {
        state.stepState = { ...state.stepState, update: action?.payload };
      },
      updateAllFiles: (state, action) => {
        const payload = action?.payload;
        state.stepState = {
          ...state.stepState,
          trainingVoice: payload?.training_voice,
          file: payload?.file,
          img1: payload?.img1,
          img2: payload?.img2,
          importantPointsVoice: payload?.important_points_voice,
        };
      },
      updateVideo: (state, action) => {
          state.stepState = {
              ...state.stepState,
              file: action?.payload?.file
          }
          // if(action?.payload?.id){
          //     const index = state.myMovements.findIndex((item) => item.motion_id === Number(action?.payload?.id))
          //     state.myMovements[index].file = action?.payload?.file
          // }
          state.selectedOrNewMovement = {
              ...state.selectedOrNewMovement,
              file: action?.payload?.file
          }
      },
      updateImage1: (state, action) => {
          state.stepState = {
              ...state.stepState,
              img1: action?.payload?.img1
          }
          state.selectedOrNewMovement = {
              ...state.selectedOrNewMovement,
              img1: action?.payload?.img1
          }
      },
      updateImage2: (state, action) => {
          state.stepState = {
              ...state.stepState,
              img2: action?.payload?.img2
          }
          state.selectedOrNewMovement = {
              ...state.selectedOrNewMovement,
              img2: action?.payload?.img2
          }
      },
      updateImportantPointsVoice: (state, action) => {
          state.stepState = {
              ...state.stepState,
              importantPointsVoice: action?.payload?.voice
          }
          state.selectedOrNewMovement = {
              ...state.selectedOrNewMovement,
              important_points_voice: action?.payload?.voice
          }
      },
      updateTrainingVoice: (state, action) => {
          state.stepState = {
              ...state.stepState,
              trainingVoice: action?.payload?.voice
          }
          state.selectedOrNewMovement = {
              ...state.selectedOrNewMovement,
              training_voice: action?.payload?.voice
          }
      },
      accessNextStep: (state, action) => {
        state.stepState = { ...state.stepState, access: action?.payload };
      },
      handleStep: (state, action) => {
        const activeStep = action?.payload;
        switch (activeStep) {
          case 0:
            state.stepState = { ...state.stepState, step_1: true, step_2: false };
            break;
          case 1:
            state.stepState = {
              ...state.stepState,
              step_1: false,
              step_2: true,
              step_3: false,
            };
            break;
          case 2:
            state.stepState = {
              ...state.stepState,
              step_2: false,
              step_3: true,
              step_4: false,
            };
            break;
          case 3:
            state.stepState = {
              ...state.stepState,
              step_3: false,
              step_4: true,
              step_5: false,
            };
            break;
          case 4:
            state.stepState = {
              ...state.stepState,
              step_4: false,
              step_5: true,
              step_6: false,
            };
            break;
          case 5:
            state.stepState = { ...state.stepState, step_5: false, step_6: true };
            break;
          default:
            console.log("not found");
        }
      },
    },
    extraReducers(builder) {
        builder
            .addCase(handleGetMyMovements.fulfilled, (state, action) => {
                const data = action?.payload;
                if (data?.length > 0) {
                    state.myMovements = data;
                    state.myMovementsTemp = data;
                }
                if (data?.length >= 20) {
                    state.status.isNotMoreData = true;
                } else {
                    state.status.isNotMoreData = false;
                }
                state.status.myMovementsLoading = false;
            })
            .addCase(handleGetMyMovements.pending, (state) => {
                state.status.myMovementsLoading = true;
            });
        builder
            .addCase(updateSelectedOrNewMovementData.pending, (state, action) => {
                state.status.selectedOrNewMovementLoading = true
            })
            .addCase(updateSelectedOrNewMovementData.rejected, (state) => {
                state.status.selectedOrNewMovementLoading = "error"
            });
        builder
            .addCase(createNewMovement.fulfilled, (state, action) => {
                const payload = action?.payload
                state.status.selectedOrNewMovementLoading = false
                if (payload?.data?.is_successful) {
                    state.motionId = payload?.data?.motion_id
                }
            })
            .addCase(createNewMovement.pending, (state) => {
                state.status.selectedOrNewMovementLoading = true
            })
            .addCase(createNewMovement.rejected, (state) => {
                state.status.selectedOrNewMovementLoading = "error"
            })
    },
});

export const {clearAllStepStateData, setUpdate, updateAllFiles, updateVideo, updateImage1, updateImage2, updateImportantPointsVoice, updateTrainingVoice, accessNextStep, handleStep, updateMyMovements, updateSelectedOrNewMovement, setSelectedOrNewMovementLoading, updateMotionId, updateMainOrSecondaryMuscles} = myMovementsSlice.actions
export const selectMyMovements = state => state?.myMovements?.myMovements
export const selectMyMovementsTemp = state => state?.myMovements?.myMovementsTemp
export const selectMyMovementsLoading = state => state?.myMovements?.status?.myMovementsLoading
export const selectSelectedOrNewMovementLoading = state => state?.myMovements?.status?.selectedOrNewMovementLoading
export const selectMotionId = state => state?.myMovements?.motionId
export const selectIsNotMoreDate = state => state?.myMovements?.status?.isNotMoreData
export const selectStepData = state => state?.myMovements?.stepState
export const selectSelectedOrNewMovement = state => state?.myMovements?.selectedOrNewMovement
export const selectMainMuscles = state => state?.myMovements?.body_parts?.mainMuscles
export const selectSecondaryMuscles = state => state?.myMovements?.body_parts?.secondaryMuscles
export default myMovementsSlice.reducer


